import { Component, inject, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { deleteGerberFile, deleteLectraFile } from '../../../state/home.actions';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { JobStatus } from '../../../models/job-status';
import { selectIsGerberLocked, selectIsLectraLocked } from '../../../state/home.selectors';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-processing-file-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './processing-file-card.component.html',
  styleUrl: './processing-file-card.component.scss',
})
export class ProcessingFileCardComponent implements OnInit {
  @Input() fileId: string = '';
  @Input() conversionId: string = '';
  @Input() fileName: string = '';
  @Input() queuePosition: number = 0;
  @Input() fileSize: number = 0;
  @Input() jobId: string = '';
  @Input() status: JobStatus = JobStatus.Wait;
  @Input() fileUrl: string = '';
  @Input() conversionMode: string = '';
  isProcessing$: Observable<boolean> = new Observable<boolean>();
  store = inject(Store);
  protected readonly JobStatus = JobStatus;

  ngOnInit(): void {
    if (this.conversionMode === 'Lectra') {
      this.isProcessing$ = this.store.select(selectIsLectraLocked);
    } else {
      this.isProcessing$ = this.store.select(selectIsGerberLocked);
    }
  }

  protected deleteUploadedFile() {
    if (this.conversionMode == 'Lectra') {
      this.store.dispatch(deleteLectraFile({ fileId: this.fileId }));
    } else {
      this.store.dispatch(deleteGerberFile({ fileId: this.fileId }));
    }
  }
}
